import axios from "axios";

const api = () => {
  const HTTP_PROTOCOL = import.meta.env.VITE_HTTP_PROTOCOL;
  const API_URL = import.meta.env.VITE_API_URL;

  return axios.create({
    baseURL: `${HTTP_PROTOCOL}://${API_URL}`,
    withCredentials: true,
    timeout: 30000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
};

export default api;
